// src/services/apiClient.ts
import { Liferay } from './liferay';

let oAuth2Client: any;

try {
    oAuth2Client = Liferay.OAuth2Client.FromUserAgentApplication(
        'dcip-spring-boot-oauth-application-user-agent'
    );
} catch (error) {
    console.error(error);
}

const defaultHeaders = {
    'x-csrf-token': Liferay.authToken,
    jsessionid: Liferay.ThemeDisplay.getSessionId()
};

const isImpersonated = Liferay.ThemeDisplay.isImpersonated();
const doAsUserIdEncoded = Liferay.ThemeDisplay.getDoAsUserIdEncoded();

const appendDoAsUserId = (url: string) => {
    if (isImpersonated) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}doAsUserId=${encodeURIComponent(
            doAsUserIdEncoded
        )}`;
    }
    return url;
};

export const apiClient = {
    get: async <T>(url: string): Promise<T> => {
        const updatedUrl = appendDoAsUserId(url);
        const response = await oAuth2Client.fetch(updatedUrl, {
            headers: defaultHeaders,
            credentials: 'include'
        });
        const json = response;
        if (!json.success) throw new Error(json.message);
        return json;
    },

    post: async <T>(url: string, body: any): Promise<T> => {
        const updatedUrl = appendDoAsUserId(url);
        const response = await oAuth2Client.fetch(updatedUrl, {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            credentials: 'include'
        });
        const json = response;
        if (!json.success) throw new Error(json.message);
        return json;
    }
};
